const MOBILE = 'mobile';
const TABLET = 'tablet';
const DESKTOP = 'desktop';

export const Viewport = { MOBILE, TABLET, DESKTOP } as const;
/** INFO: intentional merging of value & type name */
export type Viewport = (typeof Viewport)[keyof typeof Viewport];
